export default __webpack_public_path__ + "static/media/anambra-about.eb7169e4.png";